import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/fission/banner.jpg';
import _imports_1 from '@/assets/img/fission/banner_h5.jpg';
import _imports_2 from '@/assets/img/case/bg.png';
import _imports_3 from '@/assets/img/case/bg_h5.png';
import _imports_4 from '@/assets/img/home/up_arrow.png';
import _imports_5 from '@/assets/img/home/down_arrow.png';
import _imports_6 from '@/assets/img/about/bt.jpg';
import _imports_7 from '@/assets/img/about/bt-750.jpg';
const _withScopeId = n => (_pushScopeId("data-v-4b27428c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "fission"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "banner_box"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "hidden-xs-only banner",
  src: _imports_0,
  alt: ""
}), /*#__PURE__*/_createElementVNode("img", {
  class: "hidden-sm-and-up banner",
  src: _imports_1,
  alt: ""
})], -1));
const _hoisted_3 = {
  class: "fission_box"
};
const _hoisted_4 = {
  class: "cases"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "top"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "客户成功案例")], -1));
const _hoisted_6 = {
  class: "box hidden-xs-only"
};
const _hoisted_7 = {
  class: "left-out"
};
const _hoisted_8 = {
  class: "left"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  class: "title"
};
const _hoisted_11 = {
  class: "info"
};
const _hoisted_12 = ["src"];
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "bg",
  src: _imports_2,
  alt: ""
}, null, -1));
const _hoisted_14 = ["src"];
const _hoisted_15 = {
  class: "list-out hidden-sm-and-up"
};
const _hoisted_16 = {
  class: "list"
};
const _hoisted_17 = ["onClick"];
const _hoisted_18 = {
  class: "title"
};
const _hoisted_19 = {
  class: "info"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "bg",
  src: _imports_3,
  alt: ""
}, null, -1));
const _hoisted_21 = ["src"];
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "arrow",
  src: _imports_4,
  alt: ""
}, null, -1));
const _hoisted_23 = {
  key: 1,
  class: "arrow",
  src: _imports_5,
  alt: ""
};
const _hoisted_24 = ["src"];
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "fission_header"
}, [/*#__PURE__*/_createElementVNode("div", null, "AI拓客营销核心能力"), /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "借助游戏SaaS化，融合游戏粘性与商业场景，助力企业精细化运营。"), /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "构建线上私域流量池，沉淀数据，实现高质量客户增长。。")], -1));
const _hoisted_26 = {
  class: "content"
};
const _hoisted_27 = {
  class: "card hidden-xs-only"
};
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "line"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "业务场景的应用")], -1));
const _hoisted_29 = {
  class: "list"
};
const _hoisted_30 = ["src"];
const _hoisted_31 = {
  class: "list_right"
};
const _hoisted_32 = {
  class: "card hidden-xs-only"
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "line"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "智慧营销")], -1));
const _hoisted_34 = {
  class: "list"
};
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dot"
}, null, -1));
const _hoisted_36 = {
  class: "step"
};
const _hoisted_37 = {
  class: "text"
};
const _hoisted_38 = {
  class: "card hidden-xs-only"
};
const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "line"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "3大赋能引擎")], -1));
const _hoisted_40 = {
  class: "list",
  style: {
    "justify-content": "space-around"
  }
};
const _hoisted_41 = ["src"];
const _hoisted_42 = {
  class: "list_right"
};
const _hoisted_43 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_44 = {
  class: "card"
};
const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "line"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "业务场景的应用")], -1));
const _hoisted_46 = {
  class: "list"
};
const _hoisted_47 = ["src"];
const _hoisted_48 = {
  class: "list_right"
};
const _hoisted_49 = {
  class: "card"
};
const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "line"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "智慧营销")], -1));
const _hoisted_51 = {
  class: "list"
};
const _hoisted_52 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dot"
}, null, -1));
const _hoisted_53 = {
  class: "step"
};
const _hoisted_54 = {
  class: "text"
};
const _hoisted_55 = {
  class: "card"
};
const _hoisted_56 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "line"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "3大赋能引擎")], -1));
const _hoisted_57 = {
  class: "list",
  style: {
    "justify-content": "space-around"
  }
};
const _hoisted_58 = ["src"];
const _hoisted_59 = {
  class: "list_right"
};
const _hoisted_60 = {
  class: "diverse"
};
const _hoisted_61 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header"
}, "多样化营销功能", -1));
const _hoisted_62 = {
  class: "diverse_card"
};
const _hoisted_63 = {
  class: "diverse_header"
};
const _hoisted_64 = ["src", "alt"];
const _hoisted_65 = {
  class: "title"
};
const _hoisted_66 = {
  class: "diverse_list"
};
const _hoisted_67 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dot"
}, null, -1));
const _hoisted_68 = {
  class: "info"
};
const _hoisted_69 = {
  class: "operate"
};
const _hoisted_70 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header"
}, "强大的运营支撑能力", -1));
const _hoisted_71 = {
  class: "operate_card"
};
const _hoisted_72 = ["src", "alt"];
const _hoisted_73 = {
  class: "title"
};
const _hoisted_74 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_75 = {
  class: "culture-item"
};
const _hoisted_76 = ["src", "alt"];
const _hoisted_77 = {
  class: "title"
};
const _hoisted_78 = {
  class: "culture-item"
};
const _hoisted_79 = ["src", "alt"];
const _hoisted_80 = {
  class: "title"
};
const _hoisted_81 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_82 = {
  class: "culture-item"
};
const _hoisted_83 = ["src", "alt"];
const _hoisted_84 = {
  class: "title"
};
const _hoisted_85 = {
  class: "culture-item"
};
const _hoisted_86 = ["src", "alt"];
const _hoisted_87 = {
  class: "title"
};
const _hoisted_88 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_89 = {
  class: "culture-item"
};
const _hoisted_90 = ["src", "alt"];
const _hoisted_91 = {
  class: "title"
};
const _hoisted_92 = {
  class: "culture-item"
};
const _hoisted_93 = ["src", "alt"];
const _hoisted_94 = {
  class: "title"
};
import { onMounted, onUnmounted, reactive, ref } from "vue";
import { useRouter } from "vue-router";
const __default__ = {
  metaInfo: {
    title: '互动营销-京奇数据智慧营销',
    meta: [{
      name: "description",
      content: "四川京奇数据科技有限公司的AI拓客系统是专为房地产开发商和销售团队设计的智能化营销解决方案。通过先进的人工智能技术，结合大数据分析和精准营销策略，我们帮助客户实现线上曝光量提升至20万+，线下到访量达到1000组+，显著提高楼盘销售效率和市场竞争力。了解我们的AI拓客系统如何为您的项目带来突破性增长，开启智能营销新时代。"
    }, {
      name: "keywords",
      content: "AI拓客、房地产AI营销、大数据拓客、智能营销系统、房产销售AI工具、线上曝光提升、精准营销解决方案、房地产大数据应用、智能拓客系统、AI客户获取、房地产营销创新、楼盘销售增长、智能营销平台"
    }],
    link: [{
      rel: '',
      href: ''
    }]
  }
};
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Marketing',
  setup(__props) {
    const cards = reactive([{
      img: require("@/assets/img/fission/card1.png"),
      title: "拉新裂变",
      text: ["以游戏化乐趣味连接", "企业与用户"]
    }, {
      img: require("@/assets/img/fission/card2.png"),
      title: "留存促活",
      text: ["多元化的玩法和挑战", "性提升用户自然留存"]
    }, {
      img: require("@/assets/img/fission/card3.png"),
      title: "效果转化",
      text: ["趣味+激励性任务，", "促进到访转化成交"]
    }, {
      img: require("@/assets/img/fission/card4.png"),
      title: "品牌塑造",
      text: ["多维度游戏互动，", "实现品牌曝光"]
    }]);
    const cards2 = reactive(['客户洞察，精准匹配', '全域流量，精准触达', '链式裂变，精准扩散', '数据挖掘，精准锁定', '主动转化，精准回流', '有质量的，客户增长']);
    const cards3 = reactive([{
      img: require("@/assets/img/fission/card5.png"),
      title: "流量引擎",
      text: ["全平台流量覆盖，", "互动营销精准赋能！"]
    }, {
      img: require("@/assets/img/fission/card6.png"),
      title: "数据引擎",
      text: ["客户轨迹全程跟踪，", "AI引擎预测营销！"]
    }, {
      img: require("@/assets/img/fission/card7.png"),
      title: "技术引擎",
      text: ["用户标签模型定向搭建，", "精准获客快人一步！"]
    }]);
    const cards4 = reactive([{
      img: require("@/assets/img/fission/card8.png"),
      title: "品牌塑造",
      children: [{
        info: '首屏广告',
        text: ["用户进入活动第一时间", "曝光企业的品牌"]
      }, {
        info: '视觉元素自定义',
        text: ["多模块嵌入企业品牌元素"]
      }, {
        info: '答题活动',
        text: ["答题内容植入品牌，趣味,", "答题场景", "增加品牌曝光，快速提升", "流量"]
      }]
    }, {
      img: require("@/assets/img/fission/card9.png"),
      title: "拉新裂变",
      children: [{
        info: '线上涨粉',
        text: ["0门槛抽奖游戏，精准引", "流，为企业用户拉新"]
      }, {
        info: '激励裂变',
        text: ["分享即可获得激励，激活", "更多用户，实现低成本", "高效获客"]
      }, {
        info: '一键导航',
        text: ["设置门店导航，引导顾客", "前往门店完成奖品兑换/", "商品交易"]
      }]
    }, {
      img: require("@/assets/img/fission/card10.png"),
      title: "留存促活",
      children: [{
        info: '活动周期',
        text: ["可设置每日抽奖机会、每", "日中奖机会；让用户养成", "再次访问的习惯"]
      }, {
        info: '养成活动',
        text: ["留存活动让用户留存变得", "更简单"]
      }, {
        info: '激励留存',
        text: ["分享激励、高频参与激励", "等激励方式促进高留存率"]
      }]
    }, {
      img: require("@/assets/img/fission/card11.png"),
      title: "效果转化",
      children: [{
        info: '砍价活动',
        text: ["一键生成砍价小程序", "支持多商品，支持微信收款"]
      }, {
        info: '拼团活动',
        text: ["一键生成拼团H5", "支持多商品，支持微信收款"]
      }, {
        info: '秒杀活动',
        text: ["一键生成秒杀H5", "支持多商品，支持微信收款"]
      }]
    }]);
    const cards5 = [{
      imgPath: require("@/assets/img/fission/card12.png"),
      title: '解决方案',
      intro: ['一站式解决裂变、活跃、入会、积分', '消耗、消费转化等运营难题']
    }, {
      imgPath: require("@/assets/img/fission/card13.png"),
      title: '全渠道能力支持',
      intro: ['跨渠道数据互通。小程序、公众号', '抖音、视频号、快手等多项开放']
    }, {
      imgPath: require("@/assets/img/fission/card14.png"),
      title: '专属配置',
      intro: ['权益填充，玩法设置，皮肤选择 ', '专属生成互动游戏']
    }, {
      imgPath: require("@/assets/img/fission/card15.png"),
      title: '权益供应链',
      intro: ['选权益供应链，低价有保障 ', '一站式选品采购']
    }, {
      imgPath: require("@/assets/img/fission/card16.png"),
      title: '可视化数据跟踪',
      intro: ['20+维度数据分析报表，运营', '数据看得见看得懂']
    }, {
      imgPath: require("@/assets/img/fission/card17.png"),
      title: '智能风控系统',
      intro: ['智能防刷机制，数据自动分析', '保障运营效果真实、安全、有效']
    }];
    const cases = reactive([{
      title: "#打造获客热销盛况#",
      info: "合肥-中国铁建花语天境",
      logo: require("@/assets/img/case/logo1.png"),
      img: require("@/assets/img/fission/case/1.png")
    }, {
      title: "#获客效能提升10倍#",
      info: "佛山-金地中南新城大境",
      logo: require("@/assets/img/case/logo1.png"),
      img: require("@/assets/img/fission/case/2.png")
    }, {
      title: "#成交超预期2倍多#",
      info: "武汉-招商•武汉城建未来中心",
      logo: require("@/assets/img/case/logo3.png"),
      img: require("@/assets/img/fission/case/3.png")
    }, {
      title: "#赋能成交GMV1.1亿+#",
      info: "武汉-招商•武汉城建未来中心",
      logo: require("@/assets/img/case/logo4.png"),
      img: require("@/assets/img/fission/case/4.png")
    }, {
      title: "#成交提升3倍#",
      info: "四川资阳-中交锦上",
      logo: require("@/assets/img/case/logo5.png"),
      img: require("@/assets/img/fission/case/5.png")
    }, {
      title: "#打破市场流量困境#",
      info: "武汉-中国铁建花语汀澜",
      logo: require("@/assets/img/case/logo6.png"),
      img: require("@/assets/img/fission/case/6.png")
    }]);
    const active = ref(0);
    const timer = ref();
    const per = ref(0);
    const stop = () => {
      clearInterval(timer.value);
    };
    const continueFunc = () => {
      clearInterval(timer.value);
      timer.value = setInterval(() => {
        if (per.value >= 100) {
          clearInterval(timer.value);
          setTimeout(() => {
            handleClick(active.value + 1 > 5 ? 0 : active.value + 1);
          }, 500);
          return;
        }
        per.value += 1;
      }, 100);
    };
    const init = () => {
      per.value = 0;
      continueFunc();
    };
    const handleClick = i => {
      active.value = i;
      init();
    };
    const handleTap = i => active.value = i;
    onMounted(() => {
      if (globalThis.matchMedia("(max-width: 767px)").matches) return;
      init();
    });
    onUnmounted(() => clearInterval(timer.value));
    const router = useRouter();
    const toUrl = () => {
      router.push({
        name: "login"
      });
    };
    return (_ctx, _cache) => {
      const _component_el_progress = _resolveComponent("el-progress");
      const _component_van_swipe_item = _resolveComponent("van-swipe-item");
      const _component_van_swipe = _resolveComponent("van-swipe");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cases, (item, i) => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(['card', active.value === i ? 'active' : '']),
          key: i,
          onClick: $event => handleClick(i)
        }, [_createElementVNode("div", _hoisted_10, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_11, _toDisplayString(item.info), 1), active.value === i ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createElementVNode("img", {
          class: "logo",
          src: item.logo,
          alt: ""
        }, null, 8, _hoisted_12), _hoisted_13, _createVNode(_component_el_progress, {
          class: "progress",
          percentage: per.value,
          "show-text": false,
          "stroke-width": 4
        }, null, 8, ["percentage"])], 64)) : _createCommentVNode("", true)], 10, _hoisted_9);
      }), 128))])]), _createElementVNode("div", {
        class: "right",
        onMouseenter: stop,
        onMouseleave: continueFunc
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cases, (item, i) => {
        return _openBlock(), _createElementBlock("div", {
          key: i
        }, [_createVNode(_Transition, {
          name: "slide",
          "enter-active-class": "animate__animated animate__fadeIn"
        }, {
          default: _withCtx(() => [active.value === i ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "case_img",
            src: item.img,
            alt: ""
          }, null, 8, _hoisted_14)) : _createCommentVNode("", true)]),
          _: 2
        }, 1024)]);
      }), 128))], 32)]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cases, (item, i) => {
        return _openBlock(), _createElementBlock("div", {
          key: i,
          onClick: $event => handleTap(i)
        }, [_createElementVNode("div", {
          class: _normalizeClass(['card', active.value === i ? 'active' : ''])
        }, [_createElementVNode("div", _hoisted_18, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_19, _toDisplayString(item.info), 1), active.value === i ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_hoisted_20, _createElementVNode("img", {
          class: "logo",
          src: item.logo,
          alt: ""
        }, null, 8, _hoisted_21), _hoisted_22], 64)) : (_openBlock(), _createElementBlock("img", _hoisted_23))], 2), _createVNode(_Transition, {
          name: "slide",
          "enter-active-class": "animate__animated animate__fadeIn"
        }, {
          default: _withCtx(() => [active.value === i ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "case_img",
            src: item.img,
            alt: ""
          }, null, 8, _hoisted_24)) : _createCommentVNode("", true)]),
          _: 2
        }, 1024)], 8, _hoisted_17);
      }), 128))])])]), _hoisted_25, _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_hoisted_28, _createElementVNode("div", _hoisted_29, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cards, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "list_box",
          key: item.img
        }, [_createElementVNode("div", null, [_createElementVNode("img", {
          src: item.img
        }, null, 8, _hoisted_30)]), _createElementVNode("div", _hoisted_31, [_createElementVNode("div", null, _toDisplayString(item.title), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.text, val => {
          return _openBlock(), _createElementBlock("div", {
            class: "text",
            key: val
          }, _toDisplayString(val), 1);
        }), 128))])]);
      }), 128))])]), _createElementVNode("div", _hoisted_32, [_hoisted_33, _createElementVNode("div", _hoisted_34, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cards2, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "step_box",
          key: item
        }, [_createElementVNode("div", null, [_hoisted_35, _createElementVNode("div", _hoisted_36, "STEP" + _toDisplayString(index + 1), 1)]), _createElementVNode("div", _hoisted_37, _toDisplayString(item), 1)]);
      }), 128))])]), _createElementVNode("div", _hoisted_38, [_hoisted_39, _createElementVNode("div", _hoisted_40, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cards3, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "list_box",
          key: item.img
        }, [_createElementVNode("div", null, [_createElementVNode("img", {
          src: item.img
        }, null, 8, _hoisted_41)]), _createElementVNode("div", _hoisted_42, [_createElementVNode("div", null, _toDisplayString(item.title), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.text, val => {
          return _openBlock(), _createElementBlock("div", {
            class: "text",
            key: val
          }, _toDisplayString(val), 1);
        }), 128))])]);
      }), 128))])]), _createVNode(_component_van_swipe, {
        class: "hidden-sm-and-up",
        autoplay: false,
        loop: false,
        "indicator-color": "#006CFF"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_swipe_item, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, [_hoisted_45, _createElementVNode("div", _hoisted_46, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cards, item => {
            return _openBlock(), _createElementBlock("div", {
              class: "list_box",
              key: item.img
            }, [_createElementVNode("div", null, [_createElementVNode("img", {
              src: item.img
            }, null, 8, _hoisted_47)]), _createElementVNode("div", _hoisted_48, [_createElementVNode("div", null, _toDisplayString(item.title), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.text, val => {
              return _openBlock(), _createElementBlock("div", {
                class: "text",
                key: val
              }, _toDisplayString(val), 1);
            }), 128))])]);
          }), 128))])]), _createElementVNode("div", _hoisted_49, [_hoisted_50, _createElementVNode("div", _hoisted_51, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cards2, (item, index) => {
            return _openBlock(), _createElementBlock("div", {
              class: "step_box",
              key: item
            }, [_createElementVNode("div", null, [_hoisted_52, _createElementVNode("div", _hoisted_53, "STEP" + _toDisplayString(index + 1), 1)]), _createElementVNode("div", _hoisted_54, _toDisplayString(item), 1)]);
          }), 128))])])])]),
          _: 1
        }), _createVNode(_component_van_swipe_item, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_55, [_hoisted_56, _createElementVNode("div", _hoisted_57, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cards3, item => {
            return _openBlock(), _createElementBlock("div", {
              class: "list_box",
              key: item.img
            }, [_createElementVNode("div", null, [_createElementVNode("img", {
              src: item.img
            }, null, 8, _hoisted_58)]), _createElementVNode("div", _hoisted_59, [_createElementVNode("div", null, _toDisplayString(item.title), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.text, val => {
              return _openBlock(), _createElementBlock("div", {
                class: "text",
                key: val
              }, _toDisplayString(val), 1);
            }), 128))])]);
          }), 128))])])]),
          _: 1
        })]),
        _: 1
      })]), _createElementVNode("div", _hoisted_60, [_hoisted_61, _createElementVNode("div", _hoisted_62, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cards4, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "diverse_box",
          key: item.img
        }, [_createElementVNode("div", _hoisted_63, [_createElementVNode("img", {
          src: item.img,
          alt: item.title
        }, null, 8, _hoisted_64), _createElementVNode("div", _hoisted_65, _toDisplayString(item.title), 1)]), _createElementVNode("div", _hoisted_66, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, item2 => {
          return _openBlock(), _createElementBlock("div", {
            class: "diverse_content",
            key: item2.info
          }, [_createElementVNode("div", null, [_hoisted_67, _createElementVNode("div", _hoisted_68, _toDisplayString(item2.info), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item2.text, val => {
            return _openBlock(), _createElementBlock("div", {
              class: "text",
              key: val
            }, _toDisplayString(val), 1);
          }), 128))]);
        }), 128))])]);
      }), 128))])]), _createElementVNode("div", _hoisted_69, [_hoisted_70, _createElementVNode("div", _hoisted_71, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(cards5, item => {
        return _createElementVNode("div", {
          key: item,
          class: "culture-item hidden-xs-only"
        }, [_createElementVNode("img", {
          src: item.imgPath,
          alt: item.title,
          class: "culture-img"
        }, null, 8, _hoisted_72), _createElementVNode("span", _hoisted_73, _toDisplayString(item.title), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.intro, text => {
          return _openBlock(), _createElementBlock("div", {
            key: text,
            class: "intro-text"
          }, _toDisplayString(text), 1);
        }), 128))]);
      }), 64)), _createVNode(_component_van_swipe, {
        class: "hidden-sm-and-up",
        autoplay: false,
        loop: false,
        "indicator-color": "#006CFF"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_swipe_item, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_74, [_createElementVNode("div", _hoisted_75, [_createElementVNode("img", {
            src: cards5[0].imgPath,
            alt: cards5[0].title,
            class: "culture-img"
          }, null, 8, _hoisted_76), _createElementVNode("span", _hoisted_77, _toDisplayString(cards5[0].title), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cards5[0].intro, text => {
            return _openBlock(), _createElementBlock("div", {
              key: text,
              class: "intro-text"
            }, _toDisplayString(text), 1);
          }), 128))]), _createElementVNode("div", _hoisted_78, [_createElementVNode("img", {
            src: cards5[1].imgPath,
            alt: cards5[1].title,
            class: "culture-img"
          }, null, 8, _hoisted_79), _createElementVNode("span", _hoisted_80, _toDisplayString(cards5[1].title), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cards5[1].intro, text => {
            return _openBlock(), _createElementBlock("div", {
              key: text,
              class: "intro-text"
            }, _toDisplayString(text), 1);
          }), 128))])])]),
          _: 1
        }), _createVNode(_component_van_swipe_item, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_81, [_createElementVNode("div", _hoisted_82, [_createElementVNode("img", {
            src: cards5[2].imgPath,
            alt: cards5[2].title,
            class: "culture-img"
          }, null, 8, _hoisted_83), _createElementVNode("span", _hoisted_84, _toDisplayString(cards5[2].title), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cards5[2].intro, text => {
            return _openBlock(), _createElementBlock("div", {
              key: text,
              class: "intro-text"
            }, _toDisplayString(text), 1);
          }), 128))]), _createElementVNode("div", _hoisted_85, [_createElementVNode("img", {
            src: cards5[3].imgPath,
            alt: cards5[3].title,
            class: "culture-img"
          }, null, 8, _hoisted_86), _createElementVNode("span", _hoisted_87, _toDisplayString(cards5[3].title), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cards5[3].intro, text => {
            return _openBlock(), _createElementBlock("div", {
              key: text,
              class: "intro-text"
            }, _toDisplayString(text), 1);
          }), 128))])])]),
          _: 1
        }), _createVNode(_component_van_swipe_item, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_88, [_createElementVNode("div", _hoisted_89, [_createElementVNode("img", {
            src: cards5[4].imgPath,
            alt: cards5[4].title,
            class: "culture-img"
          }, null, 8, _hoisted_90), _createElementVNode("span", _hoisted_91, _toDisplayString(cards5[4].title), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cards5[4].intro, text => {
            return _openBlock(), _createElementBlock("div", {
              key: text,
              class: "intro-text"
            }, _toDisplayString(text), 1);
          }), 128))]), _createElementVNode("div", _hoisted_92, [_createElementVNode("img", {
            src: cards5[5].imgPath,
            alt: cards5[5].title,
            class: "culture-img"
          }, null, 8, _hoisted_93), _createElementVNode("span", _hoisted_94, _toDisplayString(cards5[5].title), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cards5[5].intro, text => {
            return _openBlock(), _createElementBlock("div", {
              key: text,
              class: "intro-text"
            }, _toDisplayString(text), 1);
          }), 128))])])]),
          _: 1
        })]),
        _: 1
      })])])]), _createElementVNode("img", {
        class: "hidden-xs-only",
        src: _imports_6,
        style: {
          "width": "100%",
          "cursor": "pointer"
        },
        onClick: toUrl
      }), _createElementVNode("img", {
        class: "hidden-sm-and-up",
        src: _imports_7,
        style: {
          "width": "100%",
          "cursor": "pointer"
        },
        onClick: toUrl
      })]);
    };
  }
});